import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function validateEnrollmentChildInfo(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.validateEnrollmentChildInfo.url, { id }))
    .post()
}
